export const APP_NAME = "Sales Effectiveness";
export const APP_LINK = "sales-effectiveness";
